<template>
  <wd-config-provider :themeVars="themeVars">
    <slot />
    <wd-toast />
    <wd-message-box selector="authMessage">
      请您及时进行
      <text class="text-[#ffb606]">实名认证</text>
      否则将无法正常进行业务操作
    </wd-message-box>
    <wd-message-box selector="postAuthMessage">您的账号还未完成认证,暂无此项权限</wd-message-box>
    <wd-message-box selector="agreementMessage">
      您有
      <text class="text-[#ffb606]">{{ updateAgreeCount }}</text>
      份协议已更新，请阅读并同意，否则将影响到您的正常业务
    </wd-message-box>
    <wd-message-box selector="contractMessage">
      您有
      <text class="text-[#ffb606]">{{ useStore?.userInfo.contractFinish }}</text>
      份重要文件需要
      <text class="text-[#ffb606]">签收</text>
      ，否则将无法正常进行新的交易业务
    </wd-message-box>
    <wd-message-box />
  </wd-config-provider>
</template>

<script lang="ts" setup>
import type { ConfigProviderThemeVars } from 'wot-design-uni'
import { useCommonStore, useUserStore } from '@/store'
const themeVars: ConfigProviderThemeVars = {
  buttonPrimaryBgColor: '#FFB606',
  buttonInfoBgColor: '#fff',
  buttonPrimaryColor: '#fff',
  checkboxCheckedColor: '#FFB606',
}
const useStore = useUserStore()
const commonStore = useCommonStore()

const updateAgreeCount = computed(() => commonStore.updateAgreementCount)
</script>
